export default __webpack_public_path__ + "static/media/coin2.16785797.png";